export default __webpack_public_path__ + "static/media/0xe1604b54cac27970aa67b4e38495f206b59cee42.7bd1c8d6.svg";